import { FC, useState, useEffect } from "react";
import { style } from "typestyle";
import { dictionary } from "../../state/common/constants/dictionary.constants";
import { routes } from "../../state/common/constants/routes.constants";
import { InjectionService } from "../../state/common/injection.service";
import { Router } from "../elements/router.element";
import Toast from "../statics/toast";
import { useAuthContext } from "../../state/authentication/authentication.context";
import { authenticationService } from "../../state/authentication/authentication.service";
import { ssoTokensService } from "../../state/sso-tokens.service";
import { useModalContext } from "../../state/common/contexts/modal.context";
import { isIosApp } from "../../utils/is-native-app.utils";
import { appStoreListing } from "../../constants/app-store.constants";
import { NewAppModal } from "./modals/new-app-modal.template";

export const App: FC = () => {
  const authHook = useAuthContext();
  const [isValidated, setIsValidated] = useState(false);
  const { openModal } = useModalContext();

  useEffect(() => {
    // inform iOS wrapper users about the new app on every page load
    const listing = appStoreListing;
    if (isIosApp && listing) {
      openModal(() => (
        <NewAppModal
          appName={listing.name}
          appStoreUrl={listing.url}
          appIcon={listing.icon}
        />
      ));
    }
  }, [openModal]);

  useEffect(() => {
    const getSessionFromUrl = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      // if the url contains a ?token, store it before validating
      const token = searchParams.get("token");
      if (token) {
        authenticationService.setSession({
          token,
          userId: "",
          timestamp: new Date(),
        });

        // remove the token from the url
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
        window.close();
      }

      const ssoToken = searchParams.get("ssoToken");
      if (ssoToken) {
        try {
          const { data: token } = await ssoTokensService.redeem(ssoToken);
          authenticationService.setSession({
            token: token.token,
            userId: "",
            timestamp: new Date(),
          });
        } catch (error) {
          // eslint-disable-next-line no-console -- Log the error but continue with validation to clear any existing session
          console.error("SSO Token redemption failed", error);
        }
      }

      authHook
        .validate()
        .catch(async () => {
          await authHook.logout();
          Toast.error({
            body: dictionary.texts.autoSignInError,
          });
        })
        .finally(() => {
          setIsValidated(true);
          InjectionService.showWebview();
        });
    };

    getSessionFromUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- just run the validation once
  }, []);

  return (
    <div className={styles.app}>
      {isValidated === true && <Router routes={Object.values(routes)} />}
    </div>
  );
};

const styles = {
  app: style({
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    position: "relative",
  }),
};
